import Component from 'vue-class-component';
import { Mixins , Prop , Watch} from 'vue-property-decorator';
import { IparamsSplitTabs } from '@/courses/interfaces/params-split-tabs.interface';
import { IparamsSplitOrientation } from '@/courses/interfaces/params-split-orientation.interface';
import EdSplitVertical from '@/courses/components/ed-split-vertical/ed-split-vertical.vue';
import EdSplitHorizontal from '@/courses/components/ed-split-horizontal/ed-split-horizontal.vue';
import EdSplitTabs from '@/courses/components/ed-split-tabs/ed-split-tabs.vue';
import EdResponseTypeObject from '@/courses/components/type-object/ed-response-type-object-edupad/ed-response-type-object.vue';
import { CourseHomeworkSplitObjectMixin } from '@/courses/mixins/course-homework-split-object.mixin';
import { Section } from '@/courses/models/section.model';
import { WidgetTeacherHomework } from '@/homework/models/widget-teacher-homework.model';
import { ScreenMirroringMixin } from '@/screen-mirroring/mixins/screen-mirroring.mixin';
import { WidgetTeacherPerson } from '@/homework/models/widget-teacher-person.model';
import { SEND_CURRENT_SHARED_TASK_EVENT } from '@/content/values/ed-presentation-mode.values';
import EdFileViewer from '@/content/components/ed-file-viewer/ed-file-viewer.vue';

@Component({name: 'ed-homework-type-object' ,
  components: {
    EdSplitTabs,
    EdResponseTypeObject,
    EdFileViewer,
    EdSplitVertical,
    EdSplitHorizontal
   }
  })
export default class EdHomeworkTypeObject extends Mixins(CourseHomeworkSplitObjectMixin, ScreenMirroringMixin) {

  /* Props */
  @Prop() readonly courseId: number;
  @Prop() readonly response: any;
  @Prop() readonly isFeedback: boolean;
  @Prop() readonly feedback: Section;
  @Prop() readonly responseDraft: WidgetTeacherHomework;
  @Prop() readonly history: any;
  @Prop() readonly student: WidgetTeacherPerson;

  /* Computed */
  get responseHomework(): Section {
    if(this.isFeedback) {
      return this.feedback;
    }
    if(this.response) {
      return { ...this.response, assetsInfo: [this.response.homeworkAssetInfo] };
    }
    return null;
  }

  get splitTabsParams(): IparamsSplitTabs {
    return {
      contentsId: this.contentsId,
      hasSplits: true,
      oneviewSelected: this.oneviewSelected,
      tabSelected: this.tabSelected 
    }
  }

  get splitOrientationParams(): IparamsSplitOrientation {
    return {
      menuSplitFirst: this.menuProblemSplit,
      menuSplitSecond : this.menuResponseSplit,
      answer: null , isTeacher: false ,
      response: true
    }
  }

  get numberOfResponses(): number {
    return Number(JSON.parse(this.section.text).answers);
  }

  get isPresentationTeacherMode() : boolean {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  /* Methods */
  private setMenu() {
    this.firstHorizontal = true;
    this.menu = [{
      name: String(this.$i18n.t('courses.writeObject.problemTab')),
      contentId: this.contentsId.problem,
      active: !this.firstHorizontal,
      visible: true
    }];
    this.menu = this.menu.concat([{
      name: String(this.$i18n.t('courses.writeObject.responseTab')),
      contentId: this.contentsId.response,
      active: false,
      visible: true
    }]);
    this.menu = this.menu.concat([{
      name: 'SplitHorizontal',
      contentId: this.contentsId.splitHorizontal,
      active: this.firstHorizontal,
      visible: false
    },{
      name: 'SplitVertical',
      contentId: this.contentsId.splitVertical,
      active: false,
      visible: false
    }]);
  }

  public setTab(contentId: string) {
    this.settingTab({ contentId: contentId  , el: this.$refs.EdHomeworkTypeObjectTabs})
  }
  
  /* Hooks */
  created() {
    this.setFiles();
    this.setMenu();
    this.setMenuSplit(false);
  }

  mounted() {
    if(this.firstHorizontal) {
      this.setTab(this.contentsId.splitHorizontal); 
    } else {
      this.tabSelected = this.contentsId.problem;
    }
    this.problemUrl ? null : this.$emit('requestFile');

    if( this.isScreenMirroringPaperModeActive ) {
      this.setTab(this.contentsId.problem);
      this.splitTabsParams.hasSplits = false;
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.problem );
      });
    }

    if( this.isScreenMirroringBookModeActive ) {
      this.setTab(this.contentsId.response);
      this.splitTabsParams.hasSplits = false;
      this.menu.forEach(m => {
        m.visible = ( m.contentId === this.contentsId.response );
      });
    }

    if (this.isPresentationTeacherMode) {
      this.$edEventBus.$emit(SEND_CURRENT_SHARED_TASK_EVENT);
    }
  }
}